import { userThemesService } from "@/shared/themes/user-themes.service";
import { isColorDark } from "@/shared/utils/helpers";

export function updateFaqColors({ faq, theme }) {
    faq.theme = String(theme.id);
    if (theme.font) {
        faq.fontFamily = theme.font;
    }
    faq.faqColor = theme.colors.background;
    faq.titleColor = theme.colors.text;
    faq.backColor = theme.colors.cardBackground;
    faq.questionColor = theme.colors.cardText;
    faq.borderColor = theme.colors.border;
}

export function updateFaqStyle({ faq, style }) {
    faq.styleTheme = style.id;
    faq.borderRadius = style.radius;
    faq.fontFamily = style.font;
}

// @deprecated -> use 🍍pricing-creator mapThemeToPricingColors instead.
export function updatePricingColors({ pricing, theme }) {
    pricing.theme = String(theme.id);
    if (theme.font) {
        pricing.fontFamily = theme.font;
    }
    pricing.highlightColor = theme.colors.brand;
    pricing.pricingColor = theme.colors.background;
    pricing.titleColor = theme.colors.text;
    pricing.backColor = theme.colors.cardBackground;
    pricing.headingsColor = theme.colors.cardText;
    pricing.borderColor = theme.colors.border;
}

export function updatePricingStyle({ pricing, style }) {
    pricing.styleTheme = style.id;
    pricing.fontFamily = style.font;
    pricing.borderRadius = style.radius;
}

export function updateFooterColors({ footer, theme }) {
    footer.theme = String(theme.id);
    if (theme.font) {
        footer.fontFamily = theme.font;
    }
    footer.mainColor = theme.colors.brand;
    footer.background = theme.colors.background;
    footer.fontColor = theme.colors.text;
    footer.borderColor = theme.colors.border;
}

export function updateFooterStyle({ footer, style }) {
    footer.styleTheme = style.id;
    footer.fontFamily = style.font;
}

export function updateWallColors({ wall, theme }) {
    wall.theme = String(theme.id);
    if (theme.font) {
        wall.fontFamily = theme.font;
    }
    wall.wallColor = theme.colors.background;
    wall.titleColor = theme.colors.text;
    wall.backColor = theme.colors.cardBackground;
    wall.textColor = theme.colors.cardText;
    wall.borderColor = theme.colors.border;
}

export function updateWallStyle({ wall, style }) {
    wall.styleTheme = style.id;
    wall.fontFamily = style.font;
    wall.borderRadius = style.radius;
}

export function updateCookieColors({ cookie, theme }) {
    cookie.theme = String(theme.id);
    if (theme.font) {
        cookie.fontFamily = theme.font;
    }
    cookie.buttonColor = theme.colors.brand;
    cookie.backColor = theme.colors.background;
    cookie.textColor = theme.colors.text;
}

export function updateCookieStyle({ cookie, style }) {
    cookie.styleTheme = style.id;
    cookie.fontFamily = style.font;
}

export function updateCoffeeColors({ coffee, theme }) {
    coffee.theme = String(theme.id);
    if (theme.font) {
        coffee.fontFamily = theme.font;
    }
    coffee.mainColor = theme.colors.brand;
    coffee.buttonTextColor = isColorDark(theme.colors.brand) ? "#ffffff" : "#000000";
    coffee.backColor = theme.colors.background;
    coffee.textColor = theme.colors.text;
    coffee.borderColor = theme.colors.border;
}

export function updateCoffeeStyle({ coffee, style }) {
    coffee.styleTheme = style.id;
    coffee.fontFamily = style.font;
}

export function updatePlayerColors({ player, theme }) {
    player.theme = String(theme.id);
    if (theme.font) {
        player.fontFamily = theme.font;
    }
    player.mainColor = theme.colors.brand;
    player.backColor = theme.colors.background;
    player.textColor = theme.colors.text;
    player.headerColor = theme.colors.background;
    player.headingColor = theme.colors.text;
    player.borderColor = theme.colors.border;
}

export function updatePlayerStyle({ player, style }) {
    player.styleTheme = style.id;
    player.fontFamily = style.font;
}

export function updateTickerColors({ ticker, theme }) {
    ticker.theme = String(theme.id);
    if (theme.font) {
        ticker.fontFamily = theme.font;
    }
    ticker.colors.background = theme.colors.background;
    ticker.colors.text = theme.colors.text;
    ticker.colors.cardBackground = theme.colors.cardBackground;
    ticker.colors.cardText = theme.colors.cardText;
    ticker.colors.border = theme.colors.border;
}

export function updateTickerStyle({ ticker, style }) {
    ticker.styleTheme = style.id;
    ticker.fontFamily = style.font;
}

export function resetProjectTheme({ project }) {
    project.theme = userThemesService.THEME_USER_ID;
}
